import reduxQuerySync from 'redux-query-sync';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { UPDATE_NAV_ITEM } from 'store/modules/competition-nav/actions';

export const configureReduxQuerySync = (store) => {
    return reduxQuerySync({
        store,
        params: {
            competition: {
                selector: (state) =>
                    navSelector(state).competition.id?.toString(),
                action: (id) => {
                    if (!id) {
                        return { type: '' };
                    }

                    return UPDATE_NAV_ITEM.request({
                        navItem: 'competition',
                        value: { id }
                    });
                },
                stringToValue: (competition) => parseInt(competition) || null
            }
        },
        // Initially set the store's state to the current location.
        initialTruth: 'location'
    });
};
